/* Import Modules */
import axios, { AxiosRequestConfig } from "axios";
import { rentalContractEditForm } from "../../variables";
import { saveAs } from 'file-saver'
import toastr from "toastr";

const getRentalContractId = () => {
  return rentalContractEditForm.scheduleId;
};

const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: `/api/rental_contract_export/${getRentalContractId()}`,
    method: "GET",
    responseType: "blob",
    data: {},
  };

  return axiosOptions;
};

export const exportRentalContract = async () => {
  const axiosOptions = await getAxiosOptions();
  axios(axiosOptions)
    .then((result) => {
      let mineType = result.headers["content-type"];
      let rentCarNo = rentalContractEditForm.rentCarNo;
      rentCarNo = rentCarNo.replace(/\s+/g, "");
      const today = new Date();
      const exportDate = getExportDate(today);
      const name = "自動車貸渡契約書_" + rentCarNo + "_" + exportDate + ".pdf";
      const blob = new Blob([result.data], { type: mineType });
      saveAs(blob, name);
    })
    .catch((error) => {
      toastr.error("予期せぬエラーが発生しました");
      console.log(error);
    });
};

const getExportDate = (today) => {
  const hour = today.getHours();
  const minute = today.getMinutes();
  const second = today.getSeconds();
  const year = today.getFullYear();
  const month = today.getMonth();
  const date = today.getDate();

  const exportDate = `${year}${month}${date}${hour}${minute}${second}`;
  return exportDate;
}